<div class="options-display" #trigger>
  <div class="select pointer" (click)="openList()" ngClass="{'open-select':isSelectOpen}">
    <!-- <p>{{optionsListDetails?.answerOptionItem.find(x=>x.id==answer.value) | json}}</p> -->
    <p *ngIf="answer.value else placeholder">{{answer.value.name}}</p>
    <img src="/assets/images/steps/dropdown.svg" class="download-img" />
  </div>
</div>

<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayOpen]="true" cdkConnectedOverlayBackdropClass="backdrop-selection"
  (backdropClick)="isSelectOpen=false" [cdkConnectedOverlayOpen]="isSelectOpen"
  [cdkConnectedOverlayPositions]="positonArea">
  <div class="overlay-warp">
    <div *ngFor="let op of optionsListDetails?.answerOptionItem" class="item"
      (click)="isDisableSignal$()?null:updateSelection(op)">
      <p *ngIf="op.name!=''" class="text">{{op.name}}</p>
      <p *ngIf="op.name==''" translate class="text">questionBoard.edit.noValue</p>
    </div>
  </div>
</ng-template>

<ng-template #placeholder>
  <p translate> questionBoard.display.choose </p>
</ng-template>